// extracted by mini-css-extract-plugin
module.exports = {"layout":"A4_16_Labels_layout__3p5KF"};